const stickyBannerElement: HTMLElement | null = document.querySelector(".special-occasion-banner") as HTMLElement | null
const cssNode = document.createTextNode("#to-top-right { bottom: 130px; !important; }")
const url = new URL(window.location.href)

if (
    stickyBannerElement !== null &&
    sessionStorage.getItem(stickyBannerElement.id ?? "sticky-banner-disabled") === null &&
    url.pathname !== "/stars/aktion"
) {
    stickyBannerElement.style.display = "initial"
    const head = document.getElementsByTagName("head")[0]
    const style = document.createElement("style")
    style.setAttribute("type", "text/css")
    style.appendChild(cssNode)
    head.appendChild(style)

    const advertId = stickyBannerElement.dataset.advertId
    const customerId = stickyBannerElement.dataset.customerId

    if (advertId && customerId && advertId !== "0" && customerId !== "0") {
        document.addEventListener("DOMContentLoaded", () => {
            window.Tracking.trackBannerEinblendung(advertId, customerId)
        })
    }

    const closeButton: HTMLElement = stickyBannerElement.querySelector(".sticky-banner-close-button") as HTMLElement
    closeButton?.addEventListener("click", () => {
        sessionStorage.setItem(stickyBannerElement.id ?? "sticky-banner-disabled", "1")
        stickyBannerElement.remove()
        cssNode.remove()
    })
}
